import { FC, useCallback } from 'react';
import IconWarning from 'src/assets/images/icons/warning-circle-grey.svg';
import IconFinished from 'src/assets/images/icons/tick-circle-light.svg';
import IconCanceled from 'src/assets/images/icons/danger-light-main.svg';
import { beautifyEnum } from 'src/utils/utility';
import { IShipmentSummaryProps } from './types';

export const LogShipmentSummary: FC<IShipmentSummaryProps> = (props) => {
  const { items } = props;

  const getSummaryIcon = useCallback((status: string) => {
    switch (status) {
      case 'approved':
        return <img src={IconFinished} alt='' />;
      case 'rejected':
        return <img src={IconCanceled} alt='' />;
      default:
        return <img src={IconWarning} alt='' />;
    }
  }, []);

  const getSummaryType = useCallback((type: string) => {
    switch (type) {
      case 'operationReview':
        return 'Logistic Review';
      case 'procurementReview':
        return 'Procurement Review';
      case 'underReview':
        return 'Under Review';
      default:
        return beautifyEnum(type);
    }
  }, []);

  return (
    <div className='max-w-[22rem] rounded-12 py-12 px-16 bg-neutral-10'>
      <div className='flex flex-col gap-12'>
        {items.map((item, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <div key={`log-summary-item${index}`} className='flex items-center gap-8 text-12 text-blue_grey-30'>
            <div className='w-16'>{getSummaryIcon(item.status)}</div>
            <div>
              {item.shipmentTotal} Shipment{item.shipmentTotal > 1 ? 's' : ''}
            </div>
            <div className='w-4 h-4 rounded-full bg-neutral-20' />
            <div>{getSummaryType(item.workflowType)}</div>
          </div>
        ))}
      </div>
    </div>
  );
};
